import { writable } from 'svelte/store';

let state = {
    archived: null,
    balance : 0,
    business: 0,
    business_name: "",
    business_number: {
        id: 671, 
        phone_number: "", 
        forward_calls_to_number: "", 
        verified: false
    },
    call_logs: {},
    can_access_call_recordings: true,
    can_invite_users: true,
    can_modify_office_hours: true,
    can_process_billings: true,
    can_see_all_call_logs: true,
    country: "",
    country_code: "",
    date_created: "",
    id: 0,
    last_modified: "",
    line: {
        username: "", 
        password: "", 
        host: ""
    },
    max_call_duration_limit: 10,
    min_call_duration_limit: 5,
    phone_number: "",
    receiver_email: "",
    receiver_name: "",
    receiver_role: "",
    ring_group_position: 0,
    user: {
        id: 0, 
        first_name: "", 
        last_name: "", 
        personal_email: ""
    },
    first_name: "",
    id: 0,
    last_name: "",
    personal_email: "",
    avatar: ""
}

let receiver = () => {
    const { subscribe, set, update } = writable(
        JSON.parse(localStorage.getItem('active_number')) || state
    );

    subscribe((value) => {
        localStorage.setItem('active_number', JSON.stringify(value));
    });

    return {
        subscribe,
        set: (data) => {
            return update((store) => ({
                ...store,
                ...data
            }));
        },
        setAvatar: avatar => {
            return update(s => ({
                ...s,
                avatar
            }))
        }
    };
};

export default receiver();
